import crypto from "crypto-browserify";

export function createHash(val: string): string {
  return crypto.createHash("sha256").update(val).digest("hex").slice(0, 32);
}
